import { render, staticRenderFns } from "./TDWithChange.vue?vue&type=template&id=e4b9031c&"
import script from "./TDWithChange.vue?vue&type=script&lang=js&"
export * from "./TDWithChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports